module.exports = __webpack_public_path__ + "img/icon_menu_down.16a26295.svg";